import { render, staticRenderFns } from "./Spacing.vue?vue&type=template&id=84b5d440&"
import script from "./Spacing.vue?vue&type=script&lang=ts&"
export * from "./Spacing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports